import { ICellRendererParams } from "ag-grid-community";

export const BooleanIconRenderer = (params: ICellRendererParams) => {
  if (!params.colDef?.field) {
    return;
  }

  const value = params.data[params.colDef.field];

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {value ? (
        <span style={{ color: "green", fontSize: "18px" }}>✓</span>
      ) : (
        <span style={{ color: "red", fontSize: "18px" }}>✗</span>
      )}
    </div>
  );
};
